module.exports = __webpack_public_path__ + "producr-dried fresh-grass-03.jpg?ad60fbafd83a83b9525cc4525b5c5c65";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-03.jpg
// module id = 61
// module chunks = 0